module.exports = require("babel-runtime/core-js/object/assign");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/assign"
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 14 15 17 19 20 21